import { createRootRoute, Outlet } from "@tanstack/react-router";
import Header from "@/components/header/header";
import ErrorPage from "@/components/ui/errorPage";
// import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { RouteTransitionHandler } from "@/components/ui/route-transition-handler";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/services/auth/auth-context";

export const Route = createRootRoute({
  component: () => (
    <AuthProvider>
      <RouteTransitionHandler>
        <div id="root-layout">
          <Header />
          <Toaster />
          <main className="min-h-[80vh]">
            <Outlet />
          </main>
        </div>
      </RouteTransitionHandler>
    </AuthProvider>
  ),
  notFoundComponent: () => <ErrorPage />,
});
